import { Menu, MenuItem } from '@mui/material'
import dayjs from 'dayjs'
// import React, { useState, useEffect, useMemo } from 'react'
import React, { useState, useEffect } from 'react'
import SvgMarker from '#/assets/images/card/map-marker.svg'
// import SvgCMAAdd from '#/assets/images/icons/cma_add.svg'
// import SvgCMANew from '#/assets/images/icons/cma_new.svg'
// import SvgCompare from '#/assets/images/icons/compare_add.svg'
import SvgMore from '#/assets/images/icons/more_vert.svg'
import SvgShare from '#/assets/images/icons/share.svg'
import SvgLike from '#/assets/images/workspace/heart.svg'
import SvgUnlike from '#/assets/images/workspace/heart_outline.svg'
import SvgHide from '#/assets/images/workspace/hidden.svg'
import SvgUnhide from '#/assets/images/workspace/hidden_outline.svg'
import AuthLock from '#/components/AuthLock/AuthLock'
import Avatar from '#/components/Avatar'
import Button from '#/components/Button'
import Status from '#/components/PropertyStatus'
import Carousel from '#/components/SwipableCarousel'
import Tooltip from '#/components/Tooltip'
import { NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL } from '#/consts/neighborhood_level'
import { logEvent } from '#/services/analytics'
import { getMedia } from '#/services/property'
import cn from '#/utils/classnames'
import { useIsMounted } from '#/utils/hook'
import { commaNumber } from '#/utils/number'
// import { getNeighborhood, getPropertyMedia } from '#/utils/properties'
import { getNeighborhood } from '#/utils/properties'
// import { InfoTags } from '../InfoTags'
import type { ItemInfoProps, PropertyCardProps } from './types'

export function ItemInfo({
  comma,
  fixed,
  label,
  pluralize,
  value
}: ItemInfoProps) {
  if (value <= 0) return null

  return (
    <div className='text-center font-medium'>
      <div className='mb-[3px] text-2xs leading-none text-brown-gray'>
        {label}
        {pluralize && value > 1 && 's'}
      </div>
      <div className='text-xs text-black'>
        {isNaN(value) ?
          '-' :
          commaNumber(value, {
            maximumFractionDigits: fixed,
            useGrouping: comma
          })}
      </div>
    </div>
  )
}

function PropertyCard({
  className,
  // allDescription,
  autoPlay,
  currentRole,
  isMobile,
  isScrolling,
  item,
  isFavorite,
  isHidden,
  lazyload,
  mini,
  mlsLogo,
  // cmaData,
  router,
  shareProperty,
  showCTAPopup,
  showLocation,
  addToList,
  removeFromList,
  // compare,
  // setCMAData,
  ...props
}: PropertyCardProps) {
  const [images, setImages] = useState<string[]>([])
  const [count, setCount] = useState(0)
  const [imagesLoaded, setImagesLoaded] = useState(false)
  const [menuEl, setMenuEl] = React.useState<Element | null>(null)
  // const [canAddToCMA, canStartNewCMA] = useMemo(() => {
  //   if (!cmaData) return [false, false]
  //   return [
  //     Boolean(cmaData.length && !cmaData.find(e => e.id === item.id)),
  //     Boolean(cmaData[0]?.id !== item.id)
  //   ]
  // }, [cmaData])
  const isMounted = useIsMounted()

  useEffect(() => {
    // async function setImageData() {
    //   const media = await getPropertyMedia(item)

    //   if (isMounted.current) {
    //     setImages(media.photos)
    //     setCount(media.count)
    //     setImagesLoaded(media.count === media.photos.length)
    //   }
    // }

    if (isMounted.current) {
      setImages(item.media?.photos || [])
      setCount(item.media?.count || 0)
      setImagesLoaded(true)
    }

    // setImageData()
  }, [item, isMounted])

  const actionButtonClass = 'hover:bg-gray-100 rounded-full h-[30px] w-[30px]'
  const priceTypeClass = 'text-[11px] mb-0.5 leading-[normal]'
  const priceClass = 'text-sm font-bold tracking-[-0.08px] mb-px leading-[normal]'
  const pricePerSqftClass = 'text-[11px] leading-[normal]'

  function loadImages() {
    if (!lazyload) return
    const { media } = item

    if (imagesLoaded) return
    if (!media || !media.count) return
    if (count === images.length) return

    setImagesLoaded(true)

    getMedia(item.id)
      .then(media => {
        if (isMounted.current) {
          setImages(media ? media.photos : [])
        }
      })
      .catch(console.error)

    logEvent('select_content', {
      content_type: 'property_card',
      item_id: 'load_more_images',
      value: item.id,
      address: item.address.FullAddress
    })
  }

  function stopPropagation(ev: React.MouseEvent) {
    ev.preventDefault()
    ev.stopPropagation()
  }

  function onShare(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    stopPropagation(ev)
    if (!shareProperty) return

    shareProperty(item)
    logEvent('share', {
      content_type: 'property_card',
      item_id: item.id,
      value: item.address.FullAddress
    })
  }

  function onFavorite(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    stopPropagation(ev)

    if (isFavorite) {
      removeFromList && removeFromList({
        propertyId: item.id,
        listId: 'favorites',
        workspaceId: 'default'
      })
    } else {
      isHidden && removeFromList && removeFromList({
        propertyId: item.id,
        listId: 'hidden',
        workspaceId: 'default'
      })
      addToList && addToList({
        propertyId: item.id,
        listId: 'favorites',
        workspaceId: 'default'
      })
    }

    logEvent('select_content', {
      content_type: 'property_card',
      item_id: 'favorite',
      value: item.id,
      address: item.address.FullAddress,
      update: isFavorite ? 'unfavorite' : 'favorite'
    })
  }

  function onHide(ev: React.MouseEvent) {
    stopPropagation(ev)

    if (isHidden) {
      removeFromList && removeFromList({
        propertyId: item.id,
        listId: 'hidden',
        workspaceId: 'default'
      })
    } else {
      isFavorite && removeFromList && removeFromList({
        propertyId: item.id,
        listId: 'favorites',
        workspaceId: 'default'
      })
      addToList && addToList({
        propertyId: item.id,
        listId: 'hidden',
        workspaceId: 'default'
      })
    }

    logEvent('select_content', {
      content_type: 'property_card',
      item_id: 'hidden',
      value: item.id,
      address: item.address.FullAddress,
      update: isHidden ? 'unhide' : 'hide'
    })
  }

  // function onCompare(ev: React.MouseEvent) {
  //   stopPropagation(ev)

  //   if (compare) compare(item)
  //   logEvent('select_content', {
  //     content_type: 'property_card',
  //     item_id: 'add_to_compare',
  //     value: item.id,
  //     address: item.address.FullAddress
  //   })
  // }

  function onLocation(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    stopPropagation(ev)

    if (showLocation) showLocation(item)
    logEvent('select_content', {
      content_type: 'property_card',
      item_id: 'show_location',
      value: item.id,
      address: item.address.FullAddress
    })
  }

  function onMenuOpen(ev: React.MouseEvent) {
    setMenuEl(ev.currentTarget)
  }

  function onMenuClose() {
    setMenuEl(null)
  }

  // function onStartNewCMA() {
  //   if (setCMAData) {
  //     setCMAData([{ id: item.id }])
  //     if (router) router.push('/cma')
  //   }

  //   logEvent('select_content', {
  //     content_type: 'property_card',
  //     item_id: 'start_new_cma',
  //     value: item.id,
  //     address: item.address.FullAddress
  //   })
  // }

  // function onAddToCMA() {
  //   if (cmaData && setCMAData) {
  //     setCMAData([
  //       ...cmaData,
  //       { id: item.id }
  //     ])
  //   }

  //   logEvent('select_content', {
  //     content_type: 'property_card',
  //     item_id: 'add_to_cma',
  //     value: item.id,
  //     address: item.address.FullAddress
  //   })
  // }

  function renderPrices() {
    const label = item.RentFlag ?
      'Rental Price / Month' :
      ['Sold', 'PrivateSale'].includes(item.TophapStatus) ?
        'Sold Price' :
        'List Price'

    if (!item.Price && !item.PricePerSqft) return null

    return (
      <div className='absolute bottom-2.5 left-[15px]'>
        <span className={priceTypeClass}>{label}</span>
        <p className={priceClass}>
          {item.Price ? (
            <span>
              $
              {commaNumber(Math.round(item.Price))}
            </span>
          ) : (
            <span>&nbsp;</span>
          )}
        </p>
        <p className={pricePerSqftClass}>
          {item.LivingSqft && item.PricePerSqft ? (
            <span>
              $
              {commaNumber(Math.round(item.PricePerSqft))}
              {' '}
              / ft²
            </span>
          ) : (
            <span>&nbsp;</span>
          )}
        </p>
        <span className={priceTypeClass}>
          {item.PreviousListPriceDiff ? (
            <Tooltip
              tooltip={
                item.OriginalListPriceDiff ?
                  `$${commaNumber(
                    Math.abs(item.OriginalListPriceDiff)
                  )} (with Original List Price)` :
                  undefined
              }
              trigger='hover'
            >
              <i>
                $
                {commaNumber(Math.abs(item.PreviousListPriceDiff))}
                {' '}
                {item.PreviousListPriceDiff < 0 ? 'reduction ' : 'increase '}
                {item.PriceChangeTimestamp ? (
                  <span>
                    on&nbsp;
                    {dayjs(item.PriceChangeTimestamp).format('MM/DD/YYYY')}
                  </span>
                ) : null}
              </i>
            </Tooltip>
          ) : (
            ''
          )}
        </span>
      </div>
    )
  }

  function renderEstimates() {
    if (!item.estimates) return null

    if (!currentRole || currentRole === 'free') {
      return (
        <div className='pointer-events-auto absolute bottom-2.5 right-[15px] text-right'>
          <span className={priceTypeClass}>
            {item.RentFlag ? 'Rental Estimate / Month' : 'TopHap Estimate'}
          </span>

          <div className='relative'>
            <AuthLock
              currentRole={currentRole}
              event='property_card_estimate'
              onlyIcon
              requireRole='basic'
              showCTAPopup={showCTAPopup}
              solid
            />
            <p className={priceClass}>
              <span>&nbsp;</span>
            </p>
            <p className={pricePerSqftClass}>
              <span>&nbsp;</span>
            </p>
          </div>
        </div>
      )
    }

    const price = item.RentFlag ?
      item.estimates.rentEstimate :
      item.estimates.estimate
    const ppsf = item.RentFlag ?
      item.estimates.rentPpsqft :
      item.estimates.ppsqft
    const tooltipPrice = item.RentFlag ?
      item.estimates.estimate :
      item.estimates.rentEstimate

    const tooltip =
      tooltipPrice || item.estimates.rentYieldEstimate ? (
        <div>
          {item.estimates.date ? (
            <span className='flex justify-between'>
              <span className='mr-2'>Estimate Date:</span>
              <span>{item.estimates.date}</span>
            </span>
          ) : null}
          {tooltipPrice ? (
            <span className='flex justify-between'>
              <span className='mr-2'>
                {item.RentFlag ?
                  'TopHap Value Estimate:' :
                  'TopHap Rental Estimate:'}
              </span>
              <span>
                $
                {commaNumber(tooltipPrice)}
                {item.RentFlag ? '' : ' / month'}
              </span>
            </span>
          ) : null}
          {item.estimates.rentYieldEstimate ? (
            <span className='flex justify-between'>
              <span className='mr-2'>Estimated Rental Yield:</span>
              <span>
                {commaNumber(item.estimates.rentYieldEstimate)}
                %
              </span>
            </span>
          ) : null}
        </div>
      ) : null

    if (!price && !ppsf) return null

    return (
      <div className='pointer-events-auto absolute bottom-2.5 right-[15px] text-right leading-[normal]'>
        <Tooltip tooltip={tooltip} trigger='hover'>
          <span className={priceTypeClass}>
            {item.RentFlag ? 'Rental Estimate / Month' : 'TopHap Estimate'}
          </span>
          <p className={priceClass}>
            {price ? (
              <span>
                $
                {commaNumber(Math.round(price))}
              </span>
            ) : (
              <span>&nbsp;</span>
            )}
          </p>
          <p className={pricePerSqftClass}>
            {item.LivingSqft && ppsf ? (
              <span>
                $
                {commaNumber(Math.round(ppsf))}
                {' '}
                / ft²
              </span>
            ) : (
              <span>&nbsp;</span>
            )}
          </p>
        </Tooltip>
      </div>
    )
  }

  function renderAgent() {
    const coListTooltip = item.Agents?.CoList ? (
      <div>
        <strong>Co-Listing Agent</strong>
        <br />
        <small>{item.Agents.CoList.MemberFullName}</small>
        <br />
        <small>{item.Agents.CoList.OfficeName?.join(', ')}</small>
      </div>
    ) : null

    return (
      item.Agents?.List && (
        <section className='absolute left-[112px] right-[15px] top-[15px] flex items-center pl-4'>
          <div className='pointer-events-auto flex-1 overflow-hidden pr-2.5 text-right'>
            <Tooltip placement='right' tooltip={coListTooltip} trigger='hover'>
              <p className='overflow-hidden text-ellipsis text-xs font-bold leading-3 tracking-wide'>
                {item.Agents.List?.MemberFullName}
              </p>
              <p className='truncate text-2xs tracking-[-0.08px]'>
                {item.Agents.List?.OfficeName?.join(', ')}
              </p>
            </Tooltip>
          </div>
          <Avatar
            className='h-8 w-8 overflow-hidden text-base'
            name={item.Agents.List?.MemberFullName}
          />
        </section>
      )
    )
  }

  function renderMoreActions() {
    if (mini) return null

    const id = 'more-actions-menu'
    return (
      <div onClick={stopPropagation}>
        <Button aria-controls={id} aria-haspopup='true' className={actionButtonClass} onClick={onMenuOpen}>
          <SvgMore />
        </Button>
        <Menu
          anchorEl={menuEl}
          id={id}
          open={Boolean(menuEl)}
          onClose={onMenuClose}
        >
          <div className='flex flex-col space-y-1 text-brown-gray'>
            {/* {compare && (
              <Tooltip placement='left' tooltip='Compare Property' trigger='hover'>
                <MenuItem className='inline-flex space-x-2 py-2' onClick={onCompare}>
                  <AuthLock
                    beforeUnlock={onMenuClose}
                    currentRole={currentRole}
                    event='property_card_compare'
                    onlyIcon
                    requireRole='pro'
                    showCTAPopup={showCTAPopup}
                  />
                  <SvgCompare className='w-6' />
                  <span className='text-xs'>Add to Compare</span>
                </MenuItem>
              </Tooltip>
            )}
            {canAddToCMA && (
              <MenuItem className='inline-flex space-x-2 py-2' onClick={onAddToCMA}>
                <SvgCMAAdd className='w-6' />
                <span className='text-xs'>Add to CMA</span>
              </MenuItem>
            )}
            {canStartNewCMA && (
              <MenuItem className='inline-flex space-x-2 py-2' onClick={onStartNewCMA}>
                <AuthLock
                  beforeUnlock={onMenuClose}
                  currentRole={currentRole}
                  event='property_card_cma'
                  onlyIcon
                  requireRole='pro'
                  showCTAPopup={showCTAPopup}
                />
                <SvgCMANew className='w-6' />
                <span className='text-xs'>Start New CMA</span>
              </MenuItem>
            )} */}
            <MenuItem className='inline-flex space-x-2 py-2' onClick={onHide}>
              {isHidden ? (
                <SvgHide className='h-5 w-6' />
              ) : (
                <SvgUnhide className='h-5 w-6' />
              )}
              <span className='text-xs'>X-Out</span>
            </MenuItem>
          </div>
        </Menu>
      </div>
    )
  }

  const neighborhood = getNeighborhood(item.zones, NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL)
  const isAcres = item.LotAcres > 0.25

  return (
    <div className={cn('bg-white overflow-hidden rounded-xl', className)} {...props}>
      <section className='relative cursor-pointer bg-brown-gray text-white'>
        <Carousel
          autoPlay={autoPlay}
          count={count}
          images={images}
          isMobile={isMobile}
          isScrolling={isScrolling}
          onScroll={loadImages}
        />

        <div
          className='pointer-events-none absolute inset-0'
          style={{ backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(46, 46, 46, 0.5) 15%, rgba(0, 0, 0, 0) 50%, rgba(46, 46, 46, 0.5) 81%, rgba(0, 0, 0, 0.8))' }}
        >
          <Status
            classes={{
              root: 'left-[15px] absolute top-2.5',
              updated: 'h-9 bg-black bg-opacity-50 left-0 ml-0 pt-[17px] px-0 pb-0 absolute text-center top-1.5 w-full leading-relaxed'
            }}
            property={item}
          />
          {/* <InfoTags tags={item.infoTags} /> */}
          {renderAgent()}
          {renderPrices()}
          {renderEstimates()}
        </div>
      </section>

      <section className='relative mb-2 px-[15px] pb-2.5 pt-2'>
        <div className='mb-2.5 flex items-center'>
          {mini || !showLocation ? null : (
            <Tooltip tooltip='Locate Property on Map' trigger='hover'>
              <Button className='-ml-1.5 mr-1.5 h-[30px] w-[30px] rounded-full bg-primary bg-opacity-10 text-primary hover:bg-opacity-20' onClick={onLocation}>
                <SvgMarker />
              </Button>
            </Tooltip>
          )}
          <div className='flex-1 overflow-hidden whitespace-nowrap tracking-[-0.08px]'>
            <div className='mb-0.5 overflow-hidden text-ellipsis text-sm font-bold leading-4 text-black'>{item.displayAddress}</div>
            <div className='overflow-hidden text-ellipsis text-[11px] leading-tight'>
              {item.displayRegion}
              {neighborhood ? ` (${neighborhood.name})` : ''}
            </div>
          </div>
          <div className='-mr-1.5 flex items-center text-gray-400'>
            <Button className={actionButtonClass} onClick={onFavorite}>
              {isFavorite ? (
                <SvgLike className='text-red-500' />
              ) : (
                <SvgUnlike />
              )}
            </Button>
            {shareProperty && (
              <Tooltip tooltip='Copy Link To Clipboard' trigger='hover'>
                <Button className={actionButtonClass} onClick={onShare}>
                  <SvgShare />
                </Button>
              </Tooltip>
            )}
            {renderMoreActions()}
          </div>
        </div>

        <div className='flex justify-between'>
          <ItemInfo label='Bed' pluralize value={item.BedsCount} />
          <ItemInfo label='Bath' pluralize value={item.BathsDecimal} />
          <ItemInfo comma label='Sqft' value={Math.round(item.LivingSqft)} />
          <ItemInfo
            fixed={isAcres ? 1 : 0}
            label={isAcres ? 'Lot Acres' : 'Lot Sqft'}
            value={isAcres ? item.LotAcres : item.LotAcres * 43560}
          />
          <ItemInfo label='Car' value={item.ParkingCount} />
          <ItemInfo comma={false} label='Built' value={item.YearBuilt} />
          <ItemInfo label='Permit' pluralize value={item.permitsCount} />
          <ItemInfo label='DOM' value={item.DOM} />
        </div>

        {!mini && mlsLogo && (
          <img alt={item.mls} className='absolute -top-1.5 right-2 h-[15px]' src={mlsLogo} />
        )}
      </section>
    </div>
  )
}

export default React.memo(PropertyCard)
